import { interpolate } from './layoutEngine';

const MIN_VIEWPORT = 10;

/**
 * Thumb geometry from the pointer, using the map frozen at drag start.
 * The page scroll is an output of this — feeding scrollTop back into the
 * thumb makes the two chase each other and the navigator jitters.
 */
export function boxForPointer({
  pointerY,
  offset,
  trackH,
  anchors,
  squash,
  clientHeight,
  fixedH,
}) {
  const scale = squash || 1;
  let h = fixedH > 0 ? fixedH : 0;
  if (h < MIN_VIEWPORT) h = MIN_VIEWPORT;
  if (h > trackH) h = trackH;
  const limit = Math.max(0, trackH - h);
  let top = pointerY - offset;
  if (top < 0) top = 0;
  if (top > limit) top = limit;

  let docTop = interpolate(anchors, 'mini', 'doc', top / scale);
  if (!(fixedH > 0)) {
    h = interpolate(anchors, 'doc', 'mini', docTop + clientHeight) * scale - top;
    if (h < MIN_VIEWPORT) h = MIN_VIEWPORT;
    if (top + h > trackH) {
      h = Math.max(MIN_VIEWPORT, trackH - top);
    }
  }
  return { top, h, docTop };
}
